import React from 'react';
import { ArcAlert, ArcText } from '@src/core/ui';
import { useFlightProvider } from '@src/features/order/provider';
import { EnRouteFlightModeProps } from './types';

const EnRouteFlightMode: React.FC<EnRouteFlightModeProps> = (props) => {
  const { missionId } = props;
  const { flightDataByMissionId } = useFlightProvider();
  const flightMode = missionId ? flightDataByMissionId?.[missionId]?.flightMode : undefined;

  if (!flightMode) return null;

  return (
    <ArcAlert severity='info'>
      <ArcText.h6 color='info.main'> {flightMode} </ArcText.h6>
    </ArcAlert>
  );
};

export default EnRouteFlightMode;